<template>
  <div class="calendar-wrap" ref="dayCourseView">
    <div class="calendar-head" ref="calendar-head">
      <div
        :class="`week-day ${date.today ? 'today' : ''}`"
        v-for="date in eventList"
        :key="date.date"
      >
        <p>
          周{{
            ["日", "一", "二", "三", "四", "五", "六"][
              new Date(date.date.replace(/-/g, "/")).getDay()
            ]
          }}
          {{ date.date.slice(5, 7) }}月{{ date.date.slice(8) }}日
        </p>
        <p>
          共<span :class="`${date.total ? 'mwow-green' : ''}`">{{
            date.total
          }}</span
          >课次
        </p>
      </div>
    </div>
    <div class="day-time-info">
      <div class="info-left">
        <div class="visible-wrap" :style="`height:${showViewHeight}px;`">
          <div class="visible-content" :style="`top:-${showViewTop}px;`">
            <div
              class="hour"
              v-for="(item, index) in 24"
              :key="index"
              :style="`height:${rowheight[index]}px;`"
            >
              <div class="hour-time">
                <p>{{ item - 1 >= 10 ? item - 1 : "0" + (item - 1) }}:00</p>
                <p class="course-statistics">
                  共
                  <span
                    :class="totalTimeCourse[index] === 0 ? '' : 'mwow-green'"
                    >{{ totalTimeCourse[index] }}</span
                  >
                  课次
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="time-bottom">
        <div class="info-right">
          <div
            class="visible-wrap"
            :style="`height:${showViewHeight}px;`"
            ref="dayTime"
          >
            <div
              class="visible-content"
              :style="`top:-${showViewTop}px;`"
              ref="eventTime"
            >
              <div
                class="hour"
                :id="`timejump-day-${index}`"
                v-for="(item, index) in 24"
                :key="index"
              >
                <div
                  class="day-row"
                  :id="`day-course-${index}`"
                  v-for="date in eventList"
                  :key="date.date"
                >
                  <div
                    class="lesson-wrapper"
                    v-for="(row, ind) in date.lesson_list.filter((leave) => {
                      let sHour = Number(leave.start_time.slice(0, 2));
                      return sHour >= index && sHour < index + 1;
                    })"
                    :key="ind"
                    :style="`background-color: ${
                      row.roll_call_status === 2 ? '#B8B8B8' : row.course.color
                    };
                      margin-right:5px;
                      `"
                    :class="row.in_holiday === 1 ? 'bias-bgc' : ''"
                  >
                    <slot :lesson="row" type="static"></slot>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 滚动条 -->
    <div class="scroll-bar" ref="scrollBardiv" v-show="showScrollBar">
      <div
        :style="`width:${scrWidth}px;`"
        class="scroll-bar-in"
        ref="scrollBarX"
        @mousedown="handleDown"
      ></div>
    </div>
    <div :class="`view-mode-time ${viewMode === 1 ? 'hidden' : ''}`">
      <div class="calendar-head">
        <div class="week-day"></div>
        <div
          :class="`week-day ${date.today ? 'today' : ''}`"
          v-for="date in eventList"
          :key="date.date"
        >
          <p>
            周{{
              ["日", "一", "二", "三", "四", "五", "六"][
                new Date(date.date.replace(/-/g, "/")).getDay()
              ]
            }}
            {{ date.date.slice(5, 7) }}月{{ date.date.slice(8) }}日
          </p>
          <p>
            共<span :class="`${date.total ? 'mwow-green' : ''}`">{{
              date.total
            }}</span
            >课次
          </p>
        </div>
      </div>
      <div class="day-table-wrap">
        <div class="day-table" id="day-table">
          <div
            class="content"
            :style="`top:-${showingAreaTop}px;`"
            @dragover.prevent
          >
            <div class="hour-line" v-for="index in 24" :key="index">
              <div class="row">
                <div class="box time-box">
                  {{ index - 1 >= 10 ? index - 1 : "0" + (index - 1) }}:00
                </div>
                <div class="box"></div>
              </div>
              <div class="row">
                <div class="box time-box"></div>
                <div class="box"></div>
              </div>
              <div class="row">
                <div class="box time-box"></div>
                <div class="box"></div>
              </div>
              <div class="row">
                <div class="box time-box">
                  {{ index - 1 >= 10 ? index - 1 : "0" + (index - 1) }}:30
                </div>
                <div class="box"></div>
              </div>
              <div class="row">
                <div class="box time-box"></div>
                <div class="box"></div>
              </div>
              <div class="row">
                <div class="box time-box"></div>
                <div class="box"></div>
              </div>
            </div>
            <div class="event-wrap">
              <div class="column" v-for="date in eventList" :key="date.date">
                <div
                  class="row"
                  v-for="(row, index) in date.rows"
                  :key="index"
                  :style="`margin-top:${row.margin}px;`"
                >
                  <display-item
                    :list="row.display"
                    :root-height="0"
                    :drag-start-handle="handleDragStart"
                  >
                    <template v-slot:default="slotProps">
                      <slot :lesson="slotProps.lesson"></slot>
                    </template>
                  </display-item>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import lessonDialog from "../lessonDialog.vue";
import displayItem from "./displayItem.vue";
import eventBus from "@/utils/bus";
import { dateFormat } from "@/utils/timeFormat";

export default {
  name: "storeScheduleDayView",
  components: {
    // lessonDialog,
    displayItem,
  },
  // @Prop() originEvents!: any[];
  // @Prop() originTimeRange!: any[];
  props: ["originEvents", "originTimeRange"],
  // @Watch("originEvents", { immediate: false, deep: false })
  // originEventsChange(n: any[]) {
  //   // 数组传入，刷新视图
  //   this.handleRender(n);
  //   // 时间段展示范围
  //   this.setShowingArea();
  //   this.$nextTick(() => {
  //     this.dayViewOriginEvent(this.originTimeRange);
  //   });
  // }
  watch: {
    originEvents: {
      handler(n, o) {
        // 数组传入，刷新视图
        this.handleRender(n);
        // 时间段展示范围
        this.setShowingArea();
        this.$nextTick(() => {
          this.dayViewOriginEvent(this.originTimeRange);
        });
      },
      immediate: false,
      deep: false,
    },
  },
  data() {
    return {
      eventList: [],
      resizeMark: false,
      showingAreaRange: [],
      showingAreaTop: 0,
      dragDialogData: {},
      viewMode: 1,
      showBtn: 2,
      notLeftClick: true,
      notRightClick: false,
      showViewHeight: 0,
      showViewTop: 0,
      marTop: 0,
      jumpArr: [], // 区域高度数组
      start: 0, // 开始时间
      totalTimeCourse: [], // 时间段课时数
      showNavgation: true, // 展示时间导航
      dayCourseWidth: 0, // 课次表的宽度
      downShift: false, // 是否按下了shift键
      num: 100,
      scrWidth: 200, // 滚动条宽度
      showScrollBar: true, // 显示滚动条
      rowheight: [], // 每一行的高度
    };
  },

  mounted() {
    // 视图类型监听
    eventBus.$on("sechdule-view-mode-change", (v) => {
      this.viewMode = v;
    });
  },
  beforeDestory() {
    const el = document.getElementById("layout-content");
    el.removeEventListener("scroll", () => {});
  },
  methods: {
    handleDown(e) {
      document.addEventListener("selectstart", (e) => {
        e.preventDefault();
      });
      const downDiv = this.$refs["scrollBarX"];
      const scrollDiv = this.$refs["scrollBardiv"];
      const bigcourseInfo = this.$refs["dayTime"];
      const courseInfo = this.$refs["eventTime"];
      // 获取超出视窗的宽度
      const overstepWidth = courseInfo.clientWidth - bigcourseInfo.clientWidth;
      // 获取滚动条可滚动的宽度
      const scrollableWidth = scrollDiv.clientWidth - downDiv.clientWidth;
      // 获取滚动的比例
      const scrollScale = overstepWidth / scrollableWidth;
      // 算出鼠标相对元素的位置
      const disX = e.clientX - downDiv.offsetLeft;
      document.onmousemove = (e) => {
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        const left = e.clientX - disX;
        if (left >= scrollDiv.clientWidth - downDiv.clientWidth) {
          return;
        } else {
          bigcourseInfo.scrollLeft = left * scrollScale;
        }
        if (left <= 1) {
          bigcourseInfo.scrollLeft = 0;
          downDiv.style.left = 1 + "px";
          return;
        }
        //移动当前元素
        downDiv.style.left = left + "px";
      };
      document.onmouseup = (e) => {
        // 鼠标弹起不再移动
        document.onmousemove = null;
        //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
        document.onmouseup = null;
      };
    },
    dayViewOriginEvent(v) {
      const startTime = Number(v[0].slice(0, 2));
      let endTime = Number(v[1].slice(0, 2));
      const endminute = Number(v[1].slice(3, 5));
      if (endminute > 0 && endTime > 23) {
        endTime += 1;
      }
      let viewHight = 10;
      let viewTop = 0;
      const hightArr = [];
      const topArr = [];
      this.rowheight = [];
      for (let i = startTime; i <= endTime; i++) {
        hightArr.push(
          document.getElementById(`timejump-day-${i}`)?.clientHeight
        );
      }
      for (let i = 0; i < 24; i++) {
        this.rowheight.push(
          document.getElementById(`timejump-day-${i}`)?.clientHeight
        );
      }
      for (let i = 0; i < startTime; i++) {
        topArr.push(document.getElementById(`timejump-day-${i}`)?.clientHeight);
      }
      if (hightArr.length > 0) {
        hightArr.map((item) => {
          viewHight += item;
        });
        this.showViewHeight = viewHight;
        this.jumpArr = hightArr;
        this.start = startTime;
      }
      if (topArr.length > 0) {
        topArr.map((item) => {
          viewTop += item;
        });
        viewTop += topArr.length;
        this.showViewTop = viewTop;
      }
      const totalArr = [];
      for (let i = 0; i < 24; i++) {
        totalArr.push(0);
      }
      this.eventList.map((item) => {
        item.lesson_list.map((it) => {
          const hours = Number(it.start_time.slice(0, 2));
          totalArr[hours] += 1;
        });
      });
      this.totalTimeCourse = totalArr;
      // 判断整个时间段是否有数据
      const nArr = [...totalArr];
      const newArr = nArr.sort((a, b) => a - b);
      if (newArr[newArr.length - 1] > 0) {
        this.showNavgation = true;
      } else {
        this.showNavgation = false;
      }
      // this.getWidth();
      // 重新渲染宽度
      const sl = this.$refs["eventTime"];
      sl.style.width = "1920px";
      if (sl.scrollWidth > 1920) {
        sl.style.width = sl.scrollWidth + "px";
      }
      this.dayCourseWidth = sl.clientWidth;
      const scrollDiv = this.$refs["scrollBardiv"];
      const d_c = document.getElementsByClassName("day-row");
      // 获取超出视窗的宽度
      const overstepWidth = this.dayCourseWidth - d_c[0].clientWidth;
      // 获取滚动条可滚动的宽度
      // let scrollableWidth = scrollDiv.clientWidth - downDiv.clientWidth;
      // 获取可滚动的距离
      const scrollScale = overstepWidth / 10;
      // 获取滚动条的宽度
      this.scrWidth = scrollDiv.clientWidth - scrollScale;
      const name = this.$refs["calendar-head"];
      const el = document.getElementById("layout-content");
      const wrap = document.getElementById("time-view-search-form") || 0;
      const dl = this.$refs["dayTime"];
      dl.scrollLeft = 0;
      el.addEventListener("scroll", () => {
        if (el.clientWidth !== 0) {
          name.style.width = el.clientWidth - 23 + "px";
        }
        if (el.scrollTop >= wrap.clientHeight + 128) {
          name.classList.add("top-regular");
          name.scrollTo(40, 0);
        } else {
          name.classList.remove("top-regular");
        }
      });
      const timeSlotCourseWidth = []; // 每个时间段的课次宽度
      for (let i = startTime; i <= endTime; i++) {
        timeSlotCourseWidth.push(
          document.getElementById(`day-course-${i}`)?.clientWidth
        );
      }
      // 判断每个课次的宽度有没有超过一屏
      if (timeSlotCourseWidth.length > 0) {
        const courseArr = [...timeSlotCourseWidth];
        const newCourse = courseArr.sort((a, b) => a - b);
        const vl = this.$refs["dayTime"];
        // 课次中最大的宽度大于浏览器课表右边的宽度
        if (newCourse[newCourse.length - 1] > window.innerWidth - 286) {
          this.showScrollBar = true;
        } else {
          this.showScrollBar = false;
        }
      }
      const bigcourseInfo = this.$refs["dayTime"];
      const courseInfo = this.$refs["eventTime"];
      const downDiv = this.$refs["scrollBarX"];
      bigcourseInfo.addEventListener("scroll", (e) => {
        // 获取超出视窗的宽度
        const overstepWidth =
          courseInfo.clientWidth - bigcourseInfo.clientWidth;
        // 获取滚动条可滚动的宽度
        const scrollableWidth = scrollDiv.clientWidth - downDiv.clientWidth;
        // 获取滚动的比例
        const scrollScale = overstepWidth / scrollableWidth;
        downDiv.style.left = `${bigcourseInfo.scrollLeft / scrollScale}px`;
      });
    },
    setShowingArea() {
      if (this.originTimeRange.length === 0) {
        return false;
      }
      const start = this.originTimeRange[0];
      const end = this.originTimeRange[1];
      // 计算展示范围
      const el = document.querySelectorAll(
        "#day-table .hour-line:first-child .row:first-child .box"
      );
      const firstH = el[0].clientHeight + 1;
      const rshms = start.split(":");
      const startLine =
        Number(rshms[0]) * 60 * 60 + Number(rshms[1]) * 60 + Number(rshms[2]);
      const rehms = end.split(":");
      const endLine =
        Number(rehms[0]) * 60 * 60 + Number(rehms[1]) * 60 + Number(rehms[2]);
      this.showingAreaTop = (startLine / (24 * 60 * 60)) * firstH * 6 * 24;
    },
    handleRender(arr) {
      const originData = arr || this.originEvents;
      const el = document.querySelectorAll(
        "#day-table .hour-line:first-child .row:first-child .box"
      );
      const firstW = el[0].clientWidth + 1;
      const firstH = el[0].clientHeight + 1;
      const dayW = el[1].clientWidth + 1;
      // 计算event定位
      const resArray = [];
      originData.map((date, index) => {
        if (dateFormat("YYYY-mm-dd", new Date()) === date.date) {
          date.today = true;
        }
        const rows = []; // 当前遍历行集合
        let curRow = {
          // 当前遍历行
          lessons: [],
          margin: "0",
          start: 0,
        };
        let arrEnd = new Date(date.date.replace(/-/g, "/")).getTime(); // 当前遍历结束时间，默认为遍历日期0点
        date.lesson_list.map((lesson, index) => {
          const curStart = new Date(
            date.date.replace(/-/g, "/") + " " + lesson.start_time
          ).getTime();
          const curEnd = new Date(
            date.date.replace(/-/g, "/") + " " + lesson.end_time
          ).getTime();
          lesson.height = ((curEnd - curStart) / 600000) * firstH;
          lesson.display = [];
          lesson.start_number = curStart;
          lesson.end_number = curEnd;
          if (curRow.lessons.length === 0) {
            lesson.margin = 0;
            curRow = {
              lessons: [lesson],
              margin: ((curStart - arrEnd) / 600000) * firstH,
              start: curStart,
            };
          } else {
            if (curStart >= arrEnd) {
              // 当前课时开始时间开始大于当前行结束时间时，换行
              // 处理行内布局
              const res = {
                display: [],
              };
              curRow.lessons.map((lesson) => {
                this.solveDisplay(lesson, res);
              });
              curRow.display = res.display;
              rows.push(curRow);
              lesson.margin = 0;
              curRow = {
                lessons: [lesson],
                margin: ((curStart - arrEnd) / 600000) * firstH,
                start: curStart,
              };
            } else {
              lesson.margin = ((curStart - curRow.start) / 600000) * firstH;
              curRow.lessons.push(lesson);
            }
          }
          arrEnd = curEnd > arrEnd ? curEnd : arrEnd;
          if (index === date.lesson_list.length - 1) {
            // 最后一项时
            const res = {
              display: [],
            };
            curRow.lessons.map((lesson) => {
              this.solveDisplay(lesson, res);
            });
            curRow.display = res.display;
            rows.push(curRow);
          }
        });
        resArray.push({
          ...date,
          rows,
        });
      });
      this.eventList = resArray;
    },
    solveDisplay(lesson, res) {
      if (res.display.length === 0) {
        res.display.push(lesson);
      } else {
        // 算出res的最低组序号和最低值
        const minArray = {
          array: [],
        };
        this.getMinEnd(res.display, "", minArray);
        minArray.array.sort((a, b) => {
          return a.end_number - b.end_number;
        });
        const minEnd = minArray.array[0].end_number;
        const minIndex = minArray.array[0].index.split("-");
        if (minIndex.length > 1) {
          this.solveDisplay(lesson, res.display[Number(minIndex[0])]);
        } else {
          if (lesson.start_number > minEnd) {
            this.solveDisplay(lesson, res.display[Number(minIndex[0])]);
          } else {
            res.display.push(lesson);
          }
        }
      }
    },
    getMinEnd(groups, index, res) {
      if (groups.length > 0) {
        groups.map((it, idx) => {
          if (it.display.length > 0) {
            this.getMinEnd(it.display, (index || "") + idx + "-", res);
          } else {
            res.array.push({
              end_number: it.end_number,
              index: (index || "") + idx,
            });
          }
        });
      }
    },
    handleDragStart(e, lesson) {
      const ref = document.getElementById(`event-${lesson.lesson_id}`);
      ref.style.display = "block";
      this.dragDialogData = {
        ...lesson,
        y: e.y,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.day-time-info {
  border-bottom: 1px solid #e7e8ea;
  border-right: 1px solid #e7e8ea;
  display: flex;
  .info-left {
    width: 100px;
    .visible-wrap {
      overflow-y: hidden;
      overflow-x: hidden;
      border-right: 1px solid #e7e8ea;
      .visible-content {
        position: relative;
        .hour {
          border-bottom: 1px solid #e7e8ea;
          border-left: 1px solid #e7e8ea;
          display: flex;
          .hour-time {
            color: #5c5d5e;
            margin-right: 5px;
            z-index: 100;
            background-color: #fff;
            text-align: center;
            min-height: 54px;
            padding-top: 5px;
            min-width: 100px;
            border-right: 1px solid #e7e8ea;
            .course-statistics {
              padding-top: 8px;
            }
          }
          .day-cont-right {
            overflow-x: scroll;
            width: 100%;
            // overflow: hidden;
            padding: 5px 0;
          }
        }
      }
    }
  }
  .time-bottom {
    .info-right {
      .visible-wrap {
        max-width: 1598px;
        overflow-y: hidden;
        border-right: 1px solid #e7e8ea;
        .visible-content {
          overflow-x: scroll;
          position: relative;
          .hour {
            min-height: 54px;
            padding: 5px 0 5px 5px;
            border-bottom: 1px solid #e7e8ea;
            display: flex;
            .day-row {
              position: relative;
              display: inline-flex;
              .lesson-wrapper {
                flex: 0 0 auto;
              }
              .head {
                border-top: 1px solid #e7e8ea;

                border-bottom: 1px solid #e7e8ea;
                line-height: 16px;
                padding-top: 6px;
                height: 36px;
                text-align: center;
                font-size: 12px;
                color: #5c5d5e;
                background: #f2f6fa;
                min-width: 10vw;
              }
              .hours {
                position: absolute;
                z-index: 99;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                .hour {
                  border-bottom: 1px solid #e7e8ea;
                }
              }
              .event-float-wrap {
                position: relative;
                z-index: 100;
                .row {
                }
              }
            }
          }
        }
      }
    }
  }
}
.calendar-wrap {
  height: 100%;
  &:hover {
    .scroll-bar {
      visibility: visible;
    }
  }
  .calendar-head {
    display: flex;
    .week-day {
      flex: 1;
      border: 1px solid #e7e8ea;
      line-height: 16px;
      padding-top: 6px;
      height: 36px;
      text-align: center;
      font-size: 12px;
      color: #5c5d5e;
      background: #f2f6fa;
      &.today {
        background-color: #f0fdfa;
        border-color: #38dabb;
      }
    }
  }
  .view-mode-time {
    display: flex;
    .view-mode-static {
      height: 100%;
      // display: flex;
      width: 100%;
      border: 1px solid #e7e8ea;
      // flex-direction: column;
      overflow-x: auto;
      overflow-y: hidden;
      &.hidden {
        height: 0;
      }
    }
  }
  .view-mode-time {
    height: 100%;
    width: 100%;
    display: flex;
    overflow-x: hidden;
    overflow-y: hidden;
    &.hidden {
      height: 0;
    }
    .calendar-head {
      .week-day {
        &:first-child {
          flex: 1;
          text-align: center;
        }
        &:nth-child(2) {
          border-left: 0;
          &.today {
            box-shadow: 0 0 1px 1px #38dabb;
          }
        }
      }
    }
    .day-table-wrap {
      flex: 1;
      height: 0;
      overflow: hidden scroll;
      border-bottom: 1px solid #e7e8ea;
      position: relative;
      .day-table {
        overflow: hidden;
        display: flex;
        .content {
          margin-left: 46px;
          width: 100%;
          position: relative;
          .hour-line {
            .row {
              display: flex;
              border-left: 1px solid #e7e8ea;
              &:last-child {
                .box {
                  border-bottom: 1px solid #e7e8ea;
                }
              }
              .box {
                flex: 1;
                height: 17px;
                line-height: 17px;
                border-right: 1px solid #e7e8ea;
                border-bottom: 1px dashed #e7e8ea;
                text-align: right;
                &:first-child {
                  flex: none;
                  width: 46px;
                  text-align: center;
                }
              }
            }
          }
          .event-wrap {
            position: absolute;
            top: 0;
            left: 47px;
            right: 0;
            height: 100%;
            z-index: 1;
            display: flex;
            overflow-x: scroll;
            .column {
              flex: 1;
              margin-right: 1px;
              .row {
                display: flex;
              }
            }
          }
        }
      }
    }
  }
}
.top-regular {
  position: fixed;
  top: 54px !important;
  z-index: 101;
}
.scroll-bar {
  overflow: hidden;
  // padding: 0 5px;
  box-sizing: border-box;
  z-index: 101;
  visibility: hidden;
  position: fixed;
  bottom: 20px;
  left: 50%;
  background-color: #eef3f6;
  border-radius: 12px;
  height: 14px;
  width: 700px;
  transform: translateX(-50%);
  .scroll-bar-in {
    cursor: pointer;
    position: relative;
    top: 2px;
    border-radius: 12px;
    width: 200px;
    background-color: #a7a7a7;
    height: 10px;
  }
}
.visible-wrap::-webkit-scrollbar {
  height: 0 !important;
}
</style>
